

class NuToggleCardHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
        this.toggler = /** @type {HTMLButtonElement} */ (this.querySelector(':scope > button[aria-controls]'));
        this.content = /** @type {HTMLElement} */ (document.getElementById(this.toggler.getAttribute('aria-controls')));
        this.boundToggle = this.toggle.bind(this);
    }

    connectedCallback() {
        this.toggler.addEventListener('click', this.boundToggle);
    }

    disconnectedCallback() {
        this.toggler.removeEventListener('click', this.boundToggle);
    }

    toggle() {
        this.hasAttribute('open') ? this.close() : this.open();
    }

    open() {
        this.setAttribute('open', '');
    }

    close() {
        this.removeAttribute('open');
    }

    openChange(oldval, newval) {
        if (newval !== null) {
            this.content.removeAttribute('hidden');
            this.toggler.setAttribute('aria-expanded', 'true');
        } else {
            this.content.setAttribute('hidden', 'true');
            this.toggler.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback(name, oldVal, newVal) {
        // @ts-ignore Yes I know.
        if (this?.[`${name}Change`]) {
            this[`${name}Change`](oldVal, newVal);
        }
    }
}

customElements.define('nu-toggle-card', NuToggleCardHTMLElement);